<template>
  <div id="box-publication-pc">
    <div id="box-nav" class="box-navigate">
      <div v-for="item in yearList" :key="item" :id="item + '-nav'" style="width: 100%;" @click="changeLocation(item)">
        <span><b>{{ item }}</b></span>
        <div v-if="item !== yearList[yearList.length - 1]" class="box-content-border">|</div>
      </div>
    </div>
    <div class="box-content">
      <div v-for="item in yearList" :key="item" :id="item + '-id'" style="width: 100%;padding: 10px">
        <p :id="item + '-title'" style="font-size: 24px;padding-bottom: 10px"><b>{{ item }}</b></p>
        <div>
          <div v-for="(publication, index) in publicationsMap[item]" :key="index">
            <div style="text-align:justify; font-family: arial; font-size: 16px; line-height: 1.5;padding: 10px">
              <div v-html="publication.html"></div>
            </div>
            <div style="width: 100%; text-align: center; padding-top: 14px; padding-bottom: 15px">
              <a :href="publication.pdfUrl" target="_blank">
                <img :src="publication.imgReqUrl" style="max-width:80%;vertical-align: middle; margin: 0 auto;">
              </a>
            </div>
            <el-divider></el-divider>
          </div>
        </div>
      </div>
    </div>
    <div style="clear: left"></div>
  </div>
</template>

<script>
export default {
  name: 'PublicationsPc',
  props: ['publist'],
  data () {
    return {
      currentYear: '',
      yearList: [],
      publicationsMap: {},
      publicationsInfoList: []
    }
  },
  mounted () {
    // this.publicationsInfoList = [
    //   // 文章顺序，按照年排序，拼接一次，给出指定格式html
    //   {
    //     'year': '2023',
    //     'title': 'Design and synthesis of antifungal candidates containing triazole scaffold from natural rosin against Valsa mali for crop protection',
    //     'italicsWords': ['Valsa mali'],
    //     'authors': 'Renle Xu, Kun Chen, Xu Han, Yuhang Lou, Shihao Gu, Yanqing Gao*， Shibin Shang, Zhanqian Song, Jie Song and Jian Li*',
    //     'journal': 'J. Agric. Food Chem.',
    //     'volume': '71(25)',
    //     'page': '9718–9727',
    //     'imgUrl': require('../../assets/img/publication/2023-01.png'),
    //     'url': 'https://pubs.acs.org/doi/10.1021/acs.jafc.3c02002',
    //     'pdfUrl': '/pdf/10'
    //   },
    //   {
    //     'year': '2023',
    //     'title': 'Discovery of rosin-based acylhydrazone derivatives as potential antifungal agents against rice Rhizoctonia solani for sustainable crop protection',
    //     'italicsWords': ['Rhizoctonia solani'],
    //     'authors': 'Renle Xu, Shihao Gu, Kun Chen, Jinyu Chen, Yong Wang, Yanqing Gao, Shibin Shang, Zhanqian Song, Jie Song and Jian Li*',
    //     'journal': 'Pest Manag Sci.',
    //     'volume': '79(2)',
    //     'page': '655-665',
    //     'imgUrl': require('../../assets/img/publication/2023-02.png'),
    //     'url': 'https://onlinelibrary.wiley.com/doi/10.1002/ps.7232',
    //     'pdfUrl': '/pdf/10'
    //   },
    //   {
    //     'year': '2022',
    //     'title': 'Discovery of natural rosin derivatives containing oxime ester moieties as potential antifungal agents to control tomato gray mold caused by Botrytis cinerea',
    //     'italicsWords': ['Botrytis cinerea'],
    //     'authors': 'Yanqing Gao, Renle Xu, Shihao Gu, Kun Chen, Jian Li*, Xiaohua He, Shibin Shang, Zhanqian Song, and Jie Song',
    //     'journal': 'J. Agric. Food Chem.',
    //     'volume': '70(18)',
    //     'page': '5551−5560',
    //     'imgUrl': require('../../assets/img/publication/2022-02.png'),
    //     'url': 'https://pubs.acs.org/doi/10.1021/acs.jafc.2c01532',
    //     'pdfUrl': '/pdf/10'
    //   },
    //   {
    //     'year': '2021',
    //     'title': 'Pine rosin as a valuable natural resource in the synthesis of fungicide candidates for controlling Fusarium oxysporum on cucumber',
    //     'italicsWords': ['Fusarium oxysporum'],
    //     'authors': 'Shiying Mao, Chengyu Wu, Yanqing Gao, Jin Hao, Xiaohua He, Pan Tao, Jian Li*, Shibin Shang, Zhanqian Song, Jie Song',
    //     'journal': 'J. Agric. Food Chem.',
    //     'volume': '69 (23)',
    //     'page': '6475–6484',
    //     'imgUrl': require('../../assets/img/publication/2021-01.png'),
    //     'url': 'https://pubs.acs.org/doi/10.1021/acs.jafc.1c01887',
    //     'pdfUrl': '/pdf/10'
    //   },
    //   {
    //     'year': '2020',
    //     'title': 'Antifungal application of rosin derivatives from renewable pine resin in crop protection',
    //     'italicsWords': [''],
    //     'authors': ' Pan Tao, Chengyu Wu, Jin Hao, Yanqing Gao, Xiaohua He, Jian Li*, Shibin Shang, Zhanqian Song, Jie Song*',
    //     'journal': 'J. Agric. Food Chem.',
    //     'volume': '68 (14)',
    //     'page': '4144-4154',
    //     'imgUrl': require('../../assets/img/publication/2020-01.png'),
    //     'url': 'https://pubs.acs.org/doi/10.1021/acs.jafc.0c00562',
    //     'pdfUrl': '/pdf/11'
    //   },
    //   {
    //     'year': '2020',
    //     'title': 'Antifungal application of pine derived products for sustainable forest resource exploitation',
    //     'italicsWords': [''],
    //     'authors': 'Chengyu Wu, Pan Tao, Jian Li*, Yanqing Gao, Shibin Shang, Zhanqian Song',
    //     'journal': 'Ind. Crop Prod.',
    //     'volume': '143',
    //     'page': '111892',
    //     'imgUrl': require('../../assets/img/publication/2020-02.png'),
    //     'url': 'https://doi.org/10.1016/j.indcrop.2019.111892',
    //     'pdfUrl': '/pdf/12'
    //   },
    //   {
    //     'year': '2019',
    //     'title': 'Structural modification of turpentine with natural chiral preservation and low-risk application prospects in crop protection.',
    //     'italicsWords': [''],
    //     'authors': 'Yanqing Gao, Jin Hao, Jian Li*, Zhanqian Song, Shibin Shang',
    //     'journal': 'ACS Omega.',
    //     'volume': '4 (4)',
    //     'page': '6392−6398',
    //     'imgUrl': require('../../assets/img/publication/2019-04.png'),
    //     'url': 'https://pubs.acs.org/doi/10.1021/acsomega.9b00241',
    //     'pdfUrl': '/pdf/13'
    //   },
    //   {
    //     'year': '2018',
    //     'title': 'High add valued application of turpentine in crop production through structural modification and QSAR analysis',
    //     'italicsWords': [''],
    //     'authors': 'Yanqing Gao, Jingjing Li, Jian Li*, Zhanqian Song, Shibin Shang, Xiaoping Rao',
    //     'journal': 'Molecules.',
    //     'volume': '23(2)',
    //     'page': '356',
    //     'imgUrl': require('../../assets/img/publication/2018-01.png'),
    //     'url': 'https://www.mdpi.com/1420-3049/23/2/356',
    //     'pdfUrl': '/pdf/14'
    //   },
    //   {
    //     'year': '2018',
    //     'title': 'Improved application of natural forest product terpene for discovery of potential botanical fungicide',
    //     'italicsWords': [''],
    //     'authors': 'Yanqing Gao, Yong Wang, Jian Li⁎, Shibin Shang, Zhanqian Song',
    //     'journal': 'Ind. Crop Prod.',
    //     'volume': '126',
    //     'page': '103-112',
    //     'imgUrl': require('../../assets/img/publication/2018-02.png'),
    //     'url': 'https://doi.org/10.1016/j.indcrop.2018.10.008',
    //     'pdfUrl': '/pdf/15'
    //   },
    //   {
    //     'year': '2016',
    //     'title': 'Taking advantage of a sustainable forest resource in agriculture: a value-added application of volatile turpentine analogues as botanical pesticides based on amphipathic modification and QSAR study',
    //     'italicsWords': [''],
    //     'authors': 'Jian Li, Jingjing Li, Yanqing Gao*, Shibin Shang, Zhanqiang Song, Guomin Xiao',
    //     'journal': 'ACS Sustain. Chem. Eng.',
    //     'volume': '4 (9)',
    //     'page': '4685−4691',
    //     'imgUrl': require('../../assets/img/publication/2016-01.png'),
    //     'url': 'https://pubs.acs.org/doi/10.1021/acssuschemeng.6b00819',
    //     'pdfUrl': '/pdf/16'
    //   }
    // ]
    // this.publicationsInfoList = this.publist
    this.constructHtml()
    document.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    changeLocation (idName) {
      // console.log(idName === this.currentYear)
      if (idName !== this.currentYear) {
        if (this.currentYear !== '') {
          document.getElementById(this.currentYear + '-nav').style.color = 'black'
          document.getElementById(this.currentYear + '-title').style.color = 'black'
        }
        document.getElementById(idName + '-nav').style.color = '#018636'
        document.getElementById(idName + '-title').style.color = '#018636'
        this.currentYear = idName
      }

      this.$nextTick(() => {
        document.getElementById(idName + '-id').scrollIntoView(true)
      })
    },
    clickTo (actualUrl) {
      window.open(actualUrl, '_blank')
    },
    handleScroll () {
      const scrollTop = document.documentElement.scrollTop
      // console.log(scrollTop)
      const boxNav = document.getElementById('box-nav')
      if (scrollTop > 0 && scrollTop < 260) {
        boxNav.style.top = (260 - scrollTop) + 'px'
        // console.log(500 - scrollTop)
      } else if (scrollTop >= 260) {
        boxNav.style.top = 10 + 'px'
      } else {
        boxNav.style.top = 260 + 'px'
      }
    },
    constructHtml () {
      let length = this.publicationsInfoList.length
      let publicationsMap = {}
      let yearList = []
      this.publicationsInfoList.forEach((info, index) => {
        let rank = length - index
        let title = info.title
        let year = info.year
        if (info.italicsWords.length > 0) {
          info.italicsWords.forEach(word => {
            title = title.replaceAll(word, `<i>${word}</i>`)
          })
        }
        let html = `<sapn>${rank}. ${info.authors}, <a href="${info.url}" target="_blank"><span style="color: #4530d2;">
          ${title}.</a><i>${info.journal}</i> <b>${info.year},</b> <i>${info.volume}, </i>${info.page}.</span>`
        info.html = html
        if (!publicationsMap.hasOwnProperty(year)) {
          publicationsMap[year] = []
          yearList.push(year)
        }
        publicationsMap[year].push(info)
      })
      this.publicationsMap = publicationsMap
      this.yearList = yearList.sort().reverse()
      return publicationsMap
    }
  },
  watch: {
    publist (newVal, oldVal) {
      this.publicationsInfoList = newVal
      this.constructHtml()
    },
    immediate: true
  }
}
</script>

<style scoped>
.box-navigate {
  width: 5vw;
  margin-left: 15vw;
  float: left;
  padding-bottom: 2px;
  position:fixed;
  top: 250px;
  text-align: center
}
@media screen and (max-width: 600px){
  .box-navigate {
    width: 10vw;
    margin-left: 1vw;
  }
}
.box-content {
  width: 58vw;
  margin-left: 22vw;
  float: left;
  text-align: left
}
.box-content-border {
  width: 100%;
  margin-top: 2px;
  margin-bottom: 2px
}
</style>



// WEBPACK FOOTER //
// src/views/publications/PublicationsPc.vue